module.exports = __webpack_public_path__ + "img/suit-01.5e344e25.png";